import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { CurrencyUnit } from "../models/currencyunit"; 
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class CurrencyUnitService {
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'currencyunit/id/d32a6cc9-353b-4e23-90fb-3c410cd6fd7e/';

  constructor(private httpService: HttpWrapperService, private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }

  getAllCurrencyUnits(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<CurrencyUnit>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllCurrencyUnits?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  }
 
  viewCurrencyUnit(CurrencyUnitID?: string): Observable<Array<CurrencyUnit>> {
    return this.httpService.get(this.apiEndpoint + 'viewCurrencyUnit/' + (CurrencyUnitID ? CurrencyUnitID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  saveCurrencyUnit(locations: CurrencyUnit): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'saveCurrencyUnit/', locations).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  deleteCurrencyUnit(CurrencyUnitID?: string): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'deleteCurrencyUnit/' + (CurrencyUnitID ? CurrencyUnitID : '00000000-0000-0000-0000-000000000000'), CurrencyUnitID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkDuplication(CurrencyUnitId?: string,CurrencyUnitCode?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkDuplication?CurrencyUnitId=' + (CurrencyUnitId ? CurrencyUnitId : '00000000-0000-0000-0000-000000000000')+ '&CurrencyUnitCode=' + (CurrencyUnitCode ? CurrencyUnitCode : '')).pipe(map((result: any) => {
        return result; 
    }));
  }
}
